import { createSlice } from "@reduxjs/toolkit";
import { InitialState } from './licenseModel';

const initialState: InitialState = {
    errStatus: false,    
    page : 1,
}
const licenseSlice = createSlice({
name: 'license',
initialState,
reducers:{
    setErrStatusDevice: (state, action) => {
        state.errStatus = action.payload
    },

    increased: (state) =>{
        state.page++
    },
    decreased: (state) =>{
        state.page--
    },
    
    // ordered: (state) =>{
    //     state.numOfCakes--
    // },
    // restocked: (state, action: PayloadAction<number>) => {
    //     state.numOfCakes += action.payload
    // }
}
})

export default licenseSlice.reducer
